var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.3334H14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.2169C2 11.8908 2 11.7278 2.03684 11.5743C2.0695 11.4383 2.12338 11.3082 2.19648 11.1889C2.27894 11.0543 2.39424 10.939 2.62484 10.7084L11 2.33328C11.5523 1.781 12.4477 1.781 13 2.33328C13.5523 2.88557 13.5523 3.781 13 4.33328L4.62486 12.7084C4.39425 12.939 4.27895 13.0543 4.1444 13.1368C4.0251 13.2099 3.89504 13.2638 3.75899 13.2964C3.60554 13.3333 3.44248 13.3333 3.11636 13.3333H2V12.2169Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/IconEdit.c8212aea42a2bb5b902d126cbe491324.svg";
export { ForwardRef as ReactComponent };